/// <amd-module name="TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Components/NoPublicKeysView" />
import React = require("react");
import * as Resources from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Resources";
import { Card } from "VSSUI/Card";
import { VssComponent } from "VSS/Platform/Layout";
import { ZeroData } from "VSSUI/ZeroData";
import { getAssetLocation } from "VSS/Platform/Location";
import { Link } from "VSSUI/Link";
import { FormatComponent } from "VSS/Platform/Components/Format";

const noResultsImage = "ms.vss-tfs-web/platform-content/Illustrations/general-no-results-found.svg";

export default class NoPublicKeysView extends VssComponent<{}> {
    public render() {
        return (
            <Card className="ssh-public-keys-zero-card-content" contentProps={{ contentPadding: false }}>
                <ZeroData
                    className="ssh-key-zero-data"
                    imagePath={getAssetLocation(this.context.pageContext, noResultsImage)}
                    imageAltText={Resources.NoResultsFoundText}
                    primaryText={Resources.NoSSHKeysAvailableMessage}
                    secondaryText={
                        <FormatComponent format={Resources.VisitSSHDocumentation}>
                            <Link
                                className="gen-ssh-key-link"
                                rel="nofollow noopener"
                                target="_blank"
                                aria-label={Resources.SecondaryAriaText}
                                href={Resources.HowToGenerateNewSSHPublicKey}
                            >
                                {Resources.SecondaryTextDocumentation}
                            </Link>
                            ;
                        </FormatComponent>
                    }
                />
            </Card>
        );
    }
}
